import { Row, RowList, Text3 } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

const ModalTipsToImproveConnection: React.FC = () => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);
    return (
        <div className='modalTipsToImproveConnection-page'>
            <div className='modalTipsToImproveConnection-page__title'>
                <Text3 regular>{t('tipsToImproveConnectionTitle')}</Text3>
            </div>
            <div className=' modalTipsToImproveConnection-page__content'>
                <RowList>
                    <Row
                        title={t('tipsOneToImproveConnectionTitle')}
                        description={t('tipsOneToImproveConnectionDescription')}
                    ></Row>
                    <Row
                        title={t('tipsTwoToImproveConnectionTitle')}
                        description={t('tipsTwoToImproveConnectionDescription')}
                    ></Row>
                    <Row
                        title={t('tipsThreeToImproveConnectionTitle')}
                        description={t('tipsThreeToImproveConnectionDescription')}
                    ></Row>
                    <Row
                        title={t('tipsFourToImproveConnectionTitle')}
                        description={t('tipsFourToImproveConnectionDescription')}
                    ></Row>
                    <Row
                        title={t('tipsFiveToImproveConnectionTitle')}
                        description={t('tipsFiveToImproveConnectionDescription')}
                    ></Row>
                    <Row
                        title={t('tipsSixToImproveConnectionTitle')}
                        description={t('tipsSixToImproveConnectionDescription')}
                    ></Row>
                    <Row
                        title={t('tipsSevenToImproveConnectionTitle')}
                        description={t('tipsSevenToImproveConnectionDescription')}
                    ></Row>
                    <Row
                        title={t('tipsEightToImproveConnectionTitle')}
                        description={t('tipsEightToImproveConnectionDescription')}
                    ></Row>
                    <Row
                        title={t('tipsNineToImproveConnectionTitle')}
                        description={t('tipsNineToImproveConnectionDescription')}
                    ></Row>
                    <Row
                        title={t('tipsTenToImproveConnectionTitle')}
                        description={t('tipsTenToImproveConnectionDescription')}
                    ></Row>
                </RowList>
            </div>
        </div>
    );
};

export default ModalTipsToImproveConnection;
